if (!window.productCardAddToCartInitialized) {
  window.productCardAddToCartInitialized = true;

  document.addEventListener('DOMContentLoaded', function() {
    initProductCardAddToCart();
    
    // Vérifier si on doit ouvrir le panier au chargement
    if (sessionStorage.getItem('openCartDrawer') === 'true') {
      sessionStorage.removeItem('openCartDrawer');
      
      setTimeout(() => {
        const cartButton = document.querySelector('[data-testid="cart-drawer-trigger"]');
        if (cartButton) {
          cartButton.click();
        }
      }, 500);
    }
  });

  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length) {
          initProductCardAddToCart();
        }
      });
    });

    const config = { childList: true, subtree: true };
    observer.observe(document.body, config);
  }

  function initProductCardAddToCart() {
    document.querySelectorAll('.product-card-atc-form:not(.initialized)').forEach(form => {
      form.classList.add('initialized');
      
      form.addEventListener('submit', async function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const button = this.querySelector('button');
        const originalText = button.textContent;
        
        button.disabled = true;
        button.textContent = 'Ajout...';
        
        const variantId = this.querySelector('input[name="id"]').value;
        
        // Récupérer l'image du produit
        const productCard = this.closest('.product-card, product-card');
        let productImage = '';
        if (productCard) {
          const imgElement = productCard.querySelector('img');
          if (imgElement) {
            productImage = imgElement.src;
          }
        }
        
        try {
          // Ajouter au panier
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: variantId,
              quantity: 1
            })
          });
          
          const data = await response.json();
          
          button.textContent = '✓ Ajouté';
          
          // Récupérer le nouveau panier
          const cartResponse = await fetch('/cart.js');
          const cart = await cartResponse.json();
          
          // Mettre à jour le compteur
          updateCartCount(cart.item_count);
          
          // Afficher la notification
          showNotification(data.product_title || 'Produit ajouté !', productImage, cart.item_count);
          // Marquer que le panier vient d'être mis à jour
sessionStorage.setItem('cartLastUpdate', Date.now().toString());
          
          setTimeout(() => {
            button.textContent = originalText;
            button.disabled = false;
          }, 2000);
          
        } catch (error) {
          console.error('Erreur:', error);
          button.textContent = 'Erreur';
          setTimeout(() => {
            button.textContent = originalText;
            button.disabled = false;
          }, 2000);
        }
      });
    });
  }

  function updateCartCount(itemCount) {
    // Mettre à jour tous les compteurs possibles
    const selectors = [
      '#cart-bubble-text',
      '.cart-bubble__text',
      '.cart-bubble__text-count',
      '[data-cart-count]',
      '.cart-count'
    ];
    
    selectors.forEach(selector => {
      document.querySelectorAll(selector).forEach(el => {
        el.textContent = itemCount;
        // Retirer la classe hidden si elle existe
        if (el.classList.contains('hidden')) {
          el.classList.remove('hidden');
        }
      });
    });
    
    // Gérer la visibilité de la bulle
    const cartBubble = document.querySelector('.cart-bubble');
    if (cartBubble && cartBubble.classList.contains('visually-hidden')) {
      cartBubble.classList.remove('visually-hidden');
    }
    
    // Animer le badge
    const cartIcons = document.querySelectorAll('cart-icon, .header-actions__cart-icon');
    cartIcons.forEach(icon => {
      const bubble = icon.querySelector('.cart-bubble');
      if (bubble) {
        bubble.classList.add('cart-bubble--animating');
        setTimeout(() => {
          bubble.classList.remove('cart-bubble--animating');
        }, 300);
      }
    });
  }

  function showNotification(productTitle, productImage, itemCount) {
    const oldNotif = document.querySelector('.cart-notification');
    if (oldNotif) {
      oldNotif.remove();
    }
    
    const notification = document.createElement('div');
    notification.className = 'cart-notification';
    notification.innerHTML = `
      <div class="cart-notification__wrapper">
        ${productImage ? `<img src="${productImage}" alt="${productTitle}" class="cart-notification__image">` : ''}
        <div class="cart-notification__content">
          <div class="cart-notification__header">
            <span class="cart-notification__icon">✓</span>
            <span class="cart-notification__title">Ajouté au panier</span>
          </div>
          <p class="cart-notification__product">${productTitle}</p>
          <div class="cart-notification__actions">
            <button class="cart-notification__btn cart-notification__btn--continue" onclick="this.closest('.cart-notification').remove()">
              Continuer les achats
            </button>
            <button class="cart-notification__btn cart-notification__btn--cart" onclick="openCartDrawer()">
              Voir le panier (${itemCount})
            </button>
          </div>
        </div>
      </div>
    `;
    
    document.body.appendChild(notification);
    
    setTimeout(() => {
      notification.classList.add('cart-notification--visible');
    }, 10);
    
    setTimeout(() => {
      notification.classList.remove('cart-notification--visible');
      setTimeout(() => {
        notification.remove();
      }, 300);
    }, 10000);
  }

  // Fonction pour ouvrir le tiroir avec rechargement de page
  window.openCartDrawer = function() {
    const notif = document.querySelector('.cart-notification');
    if (notif) notif.remove();
    
    // Marquer qu'on doit ouvrir le panier après rechargement
    sessionStorage.setItem('openCartDrawer', 'true');
    
    // Recharger la page
    window.location.reload();
  };

  // Ajouter les styles CSS
  if (!document.querySelector('#cart-notification-styles')) {
    const style = document.createElement('style');
    style.id = 'cart-notification-styles';
    style.textContent = `
      .cart-notification {
        position: fixed;
        top: 80px;
        right: 20px;
        z-index: 10000;
        background: #fff;
        border: 2px solid #fff;
        border-radius: 12px;
        box-shadow: 0 8px 24px rgba(0,0,0,0.2);
        opacity: 0;
        transform: translateX(400px);
        transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
        max-width: 380px;
        overflow: hidden;
      }
      
      .cart-notification--visible {
        opacity: 1;
        transform: translateX(0);
      }
      
      .cart-notification__wrapper {
        display: flex;
        gap: 16px;
        padding: 20px;
      }
      
      .cart-notification__image {
        width: 80px;
        height: 80px;
        object-fit: cover;
        border-radius: 8px;
        flex-shrink: 0;
        background: #f5f5f5;
      }
      
      .cart-notification__content {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 12px;
      }
      
      .cart-notification__header {
        display: flex;
        align-items: center;
        gap: 8px;
      }
      
      .cart-notification__icon {
        background: linear-gradient(90deg, #a313f5 0%, #f11390 50%, #a313f5 100%);
        color: #fff;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        flex-shrink: 0;
        font-weight: bold;
      }
      
      .cart-notification__title {
        font-size: 14px;
        font-weight: 600;
        color: #000;
      }
      
      .cart-notification__product {
        font-size: 13px;
        color: #666;
        margin: 0;
        line-height: 1.4;
      }
      
      .cart-notification__actions {
        display: flex;
        gap: 8px;
        margin-top: 4px;
      }
      
      .cart-notification__btn {
        flex: 1;
        padding: 10px 16px;
        border-radius: 6px;
        text-decoration: none;
        font-size: 13px;
        font-weight: 600;
        text-align: center;
        cursor: pointer;
        transition: all 0.2s ease;
        border: none;
        font-family: inherit;
      }
      
      .cart-notification__btn--continue {
        background: #fff;
        color: #000;
        border: 2px solid #e0e0e0;
      }
      
      .cart-notification__btn--continue:hover {
        background: #f5f5f5;
        border-color: #ccc;
      }
      
      .cart-notification__btn--cart {
        background: linear-gradient(90deg, #a313f5 0%, #f11390 50%, #a313f5 100%);
        background-size: 200% 100%;
        color: #fff;
        border: none;
        animation: gradientShift 3s ease infinite;
      }
      
      .cart-notification__btn--cart:hover {
        background-position: 100% 0;
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(241, 19, 144, 0.4);
      }
      
      @keyframes gradientShift {
        0%, 100% {
          background-position: 0% 50%;
        }
        50% {
          background-position: 100% 50%;
        }
      }
      
      @media (max-width: 768px) {
        .cart-notification {
          top: 70px;
          right: 10px;
          left: 10px;
          max-width: none;
        }
        
        .cart-notification__wrapper {
          padding: 16px;
        }
        
        .cart-notification__image {
          width: 60px;
          height: 60px;
        }
        
        .cart-notification__actions {
          flex-direction: column;
        }
        
        .cart-notification__btn {
          width: 100%;
        }
      }
    `;
    document.head.appendChild(style);
  }
  // Intercepter les clics sur l'icône panier pour forcer le rechargement
document.addEventListener('DOMContentLoaded', function() {
  const cartButton = document.querySelector('[data-testid="cart-drawer-trigger"]');
  
  if (cartButton) {
    cartButton.addEventListener('click', function(e) {
      // Vérifier si le panier a été mis à jour récemment (dans les 5 dernières secondes)
      const lastUpdate = sessionStorage.getItem('cartLastUpdate');
      const now = Date.now();
      
      if (lastUpdate && (now - parseInt(lastUpdate)) < 5000) {
        // Si le panier a été mis à jour récemment, recharger avant d'ouvrir
        e.preventDefault();
        e.stopPropagation();
        
        sessionStorage.setItem('openCartDrawer', 'true');
        sessionStorage.removeItem('cartLastUpdate');
        window.location.reload();
      }
    });
  }
});
}